<div class="bg-full-image" id="poppy-wrap">
  <section id="product-switch">
    <div class="flex-row">
      <div class="flex-container">
        <div class="flex-col-12">
          <h2 class="ui-headline">{{ 'productSwitch.title' | translate }}</h2>
          <p>{{ 'productSwitch.intro' | translate }}</p>
        </div>
        <div class="flex-col-12">
          <div class="product-wrap">
            <div *ngIf="!isPro" class="product-card" (click)="createNewAccount('grow')">
              <div class="title">
                <h3>
                  {{ 'productSwitch.growTile.title' | translate }}
                </h3>
                <app-ds-badge type="primary">
                  {{ 'productSwitch.growTile.badge' | translate }}
                </app-ds-badge>
              </div>
              <p>{{ 'productSwitch.growTile.subtitle' | translate }}</p>
              <p class="small">
                {{
                  'minimumInvestmentNote.short.InyovaGrow'
                    | translate: { growMinimumInvestmentAmount: MINIMUM_INVESTMENT_GROW | translateNumber: language : currency }
                }}
              </p>
              <a class="product-link" href="javascript:;">
                {{ (userAccountTypes.includes('grow') ? 'productSwitch.continue' : 'productSwitch.cta') | translate }}
                <span class="icon-i-chevron-right"></span>
              </a>
            </div>
            <div class="product-card" (click)="createNewAccount('3b')">
              <h3>{{ 'productSwitch.3bTile.title' | translate }}</h3>
              @if (isEve2EnabledFor3B) {
                <p>{{ 'productSwitch.3bTile.newSubtitle' | translate }}</p>
              } @else {
                <p>{{ 'productSwitch.3bTile.subtitle' | translate }}</p>
              }

              <p class="small">
                {{
                  'minimumInvestmentNote.short.InyovaInvestment'
                    | translate: { '3bMinimumInvestmentAmount': MINIMUM_INVESTMENT_3B | translateNumber: language : currency }
                }}
              </p>
              <a class="product-link" href="javascript:;">
                {{ (userAccountTypes.includes('3b') ? 'productSwitch.continue' : 'productSwitch.cta') | translate }}
                <span class="icon-i-chevron-right"></span>
              </a>
            </div>
            <div class="product-card" (click)="createNewAccount('3a')">
              <h3>{{ 'productSwitch.3aTile.title' | translate }}</h3>
              <app-ui-tooltip [content]="'productSwitch.3aTile.tooltip' | translate" color="yellow" size="small"></app-ui-tooltip>
              <p>{{ 'productSwitch.3aTile.subtitle' | translate }}</p>
              <p class="small">
                {{
                  'minimumInvestmentNote.short.Inyova3a'
                    | translate: { '3aMinimumInvestmentAmount': MINIMUM_INVESTMENT | translateNumber: language : currency }
                }}
              </p>
              <small>
                <img class="shield" src="/assets/images/shield-liberty.svg" alt="liberty" />
                <p class="liberty-text" (click)="stopProp($event)" [innerHtml]="'productSwitch.3aTile.note' | translate"></p>
              </small>
              <a class="product-link" href="javascript:;">
                {{ (userAccountTypes.includes('3a') ? 'productSwitch.continue' : 'productSwitch.cta') | translate }}
                <span class="icon-i-chevron-right"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
